module.exports = __webpack_public_path__ + "img/06_En.ffd5fa91.png";